// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"0b1d1924","37":"104bb29c","133":"d17607e8","194":"7dd37bec","468":"605ff848","635":"a4ebb965","676":"df635c46","680":"77a5a54d","681":"5a44114c","788":"7b6aa5fb","789":"2b1c271e","892":"c4c1467e","971":"a10434fc","973":"22e7c20a"}[chunkId] + ".chunk.js";
};